import * as React from 'react';
import { Link } from 'react-router-dom';

import { BooleanView } from 'src/core/ui/boolean.view';
import { DataTableView, Column } from 'src/core/ui/data-table.view';

interface QuotePolicyViewProps extends ComponentViewProps<DataSet<QuotePolicySummary>> {
	onItemDoubleClicked: (item?: QuotePolicySummary) => any;
}

export class QuotePolicyListView extends React.Component<QuotePolicyViewProps, any> {
	constructor(props) {
		super(props);
	}

	render() {
		const { model, onItemDoubleClicked, setBusy } = this.props;
		const columns: Column[] = [
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName',
				render: (text, record: QuotePolicySummary) => <Link to={`/bookings/quote-policies/${record.id}`}>{text}</Link>,
			},
			{
				key: 'productDisplayName',
				title: 'Product',
				dataIndex: 'productDisplayName'
			},
			{
				key: 'isActive',
				title: 'Is Active',
				dataIndex: 'isActive',
				render: (text, record) => {
					return (
						<BooleanView
							mode="display"
							value={record.isActive}
						/>
					);
				}
			}
		];

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						model={model}
						columns={columns}
						setBusy={setBusy}
						itemDoubleClick={onItemDoubleClicked}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-policies/list/quote-policy-list.view.tsx